import { formatInTimeZone, isDate } from "date-fns-tz";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  // Check if the input is a valid date
  if (isNaN(date)) {
    return "Invalid date"; // Handle invalid date case
  }

  // Check if the date is a time (i.e., contains time information)
  const isDateTime = dateString.includes("T") || dateString.includes(" ");

  // Format based on whether it's a date or date-time
  const timezone = "Asia/Kabul"; // Set the timezone to Kabul
  if (isDateTime) {
    return formatInTimeZone(date, timezone, "dd MMM yyyy h:mm a");
  } else {
    return formatInTimeZone(date, timezone, "dd MMM yyyy");
  }
};

export default formatDateTime;
